// i18n-setup.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';

//services
import { getLanguageByCulture as _getLanguageByCulture } from '@/services/auth.api.js';

//constants
import storageKeys from '@/utils/constants/storageKeys.js';
import langTypes from '@/utils/constants/lang.js';

import sessionManager from '@/utils/managers/sessionManager.js';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: localStorage.getItem(storageKeys.CURRENT_LANG_KEY) || 'es',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'es',
});

function setI18nLanguage(lang) {
  i18n.locale = lang;
  axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export async function loadLanguageAsync() {
  const lang = localStorage.getItem(storageKeys.CURRENT_LANG_KEY) || 'es';

  const hasES = !!sessionManager.get(storageKeys.ES_TRANSLATE, null);
  const hasEN = !!sessionManager.get(storageKeys.EN_TRANSLATE, null);

  if (!hasES) {
    const spanishText = (await _getLanguageByCulture(langTypes.ES)).data;
    sessionManager.set(storageKeys.ES_TRANSLATE, spanishText);
  }

  if (!hasEN) {
    const englishText = (await _getLanguageByCulture(langTypes.EN)).data;
    sessionManager.set(storageKeys.EN_TRANSLATE, englishText);
  }

  // //set messages for each lang
  i18n.setLocaleMessage('es', sessionManager.get(storageKeys.ES_TRANSLATE));
  i18n.setLocaleMessage('en', sessionManager.get(storageKeys.EN_TRANSLATE));

  //set current language
  setI18nLanguage(lang);
}
